module.exports = __webpack_public_path__ + "img/camp_shirt_gk12.fc3d723e.svg";